<template>
  <div class="flex justify-center items-center py-1">
    <span class="text-xs rounded inline-flex items-center py-1 px-2 font-medium" :class="bodyClass">
      <div
        class="absolute left-1/2 w-3 h-3 rotate-45 -translate-x-1/2"
        :class="[arrowClass, arrowDirection === 'up' ? '-top-0.5' : '-bottom-0.5']"
      ></div>
      <span class="inline-block z-10 whitespace-nowrap">
        <slot></slot>
      </span>
    </span>
  </div>
</template>

<script setup>
const props = defineProps({
  arrowDirection: {
    type: String,
    default: 'up',
    validator: (value) => ['up', 'down'].includes(value),
  },
  variant: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'bordered'].includes(value),
  },
});

const baseClass = 'bg-br-green-light text-black';

const bodyClass = computed(() => (props.variant === 'bordered' ? `${baseClass} border border-br-green` : baseClass));

const arrowClass = computed(() => {
  if (props.variant !== 'bordered') return baseClass;
  const borderSides = props.arrowDirection === 'up' ? 'border-t border-l' : 'border-b border-r';
  return `${baseClass} ${borderSides} border-br-green`;
});
</script>
